// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-input input {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 10px;\n}\n.base-input fieldset {\n  min-height: 30px;\n  border: 1px solid #dedfdd;\n  border-radius: 6px;\n  background-color: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
